module.exports = __webpack_public_path__ + "static/ilustracao-notas-fiscais-77e10e958ac5b7e5f0a7ffc97b5a66c6.svg";